<script setup>
import { ref, onMounted } from 'vue';
defineProps({
  title: { type: String, required: true },
  items: { type: Array, required: true },
});
const emit = defineEmits(['action', 'close']);
const menu = ref(null);
onMounted(() => menu.value?.querySelector('button')?.focus());
const navigate = event => {
  const buttons = [...menu.value.querySelectorAll('button')];
  const index = buttons.indexOf(document.activeElement);
  const moves = {
    ArrowDown: (index + 1) % buttons.length,
    ArrowUp: (index - 1 + buttons.length) % buttons.length,
    Home: 0,
    End: buttons.length - 1,
  };
  if (event.key in moves) {
    event.preventDefault();
    buttons[moves[event.key]]?.focus();
  }
};
</script>

<template>
  <div
    ref="menu"
    role="menu"
    :aria-label="title"
    class="absolute end-0 top-full z-50 mt-2 w-72 max-w-[calc(100vw-2rem)] rounded-xl border border-n-weak bg-n-solid-2 p-1.5 shadow-xl"
    @keydown="navigate"
    @keydown.esc.stop="emit('close')"
  >
    <p class="m-0 px-3 py-2 text-xs font-semibold text-n-slate-11">
      {{ title }}
    </p>
    <button
      v-for="item in items"
      :key="item.action"
      type="button"
      role="menuitem"
      :disabled="item.disabled"
      class="flex w-full items-center gap-3 rounded-lg p-3 text-start hover:bg-n-alpha-2 focus-visible:bg-n-alpha-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
      @click="emit('action', item)"
    >
      <div
        class="flex size-9 shrink-0 items-center justify-center rounded-lg bg-n-alpha-2 text-n-slate-11"
        aria-hidden="true"
      >
        <span :class="item.icon" class="size-5" />
      </div>
      <div class="min-w-0">
        <div class="text-sm font-medium text-n-slate-12">{{ item.label }}</div>
        <div class="mt-0.5 text-xs leading-4 text-n-slate-11">
          {{ item.description }}
        </div>
      </div>
    </button>
  </div>
</template>
